import {
  createGiftcard,
  deleteGiftcard,
  getGiftcard,
  getGiftcardsList,
  updateGiftcard,
} from '../../api/giftcards';
import Giftcard from '../../model/Giftcard';
import invalidationManager from './InvalidationManager';

const { hook: useGiftcardsList } = invalidationManager.createFetcher({
  queryKey: (companyId: string) => ['company', companyId, 'giftcards'],
  fetchFunction: async (companyId: string) => {
    return getGiftcardsList(companyId);
  },
});

// getGiftcard
const { hook: useGiftcard } = invalidationManager.createFetcher({
  queryKey: (companyId: string, giftcardId?: string) => [
    'company',
    companyId,
    'giftcards',
    giftcardId || '',
  ],
  fetchFunction: async (companyId: string, giftcardId?: string) => {
    if (!giftcardId) {
      return null;
    }
    return getGiftcard(companyId, giftcardId);
  },
});

const useUpdateGiftcardMutation = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string, giftcardId: string, data: Partial<Giftcard>) => {
    await updateGiftcard(companyId, giftcardId, data);
    await invalidationManager.invalidate(['company', companyId, 'giftcards']);
  },
});

const useCreateGiftcardMutation = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string, data: Partial<Giftcard>) => {
    await createGiftcard(companyId, data);
    await invalidationManager.invalidate(['company', companyId, 'giftcards']);
  },
});

const useDeleteGiftcardMutation = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string, giftcardId: string) => {
    await deleteGiftcard(companyId, giftcardId);
    await invalidationManager.invalidate(['company', companyId, 'giftcards']);
  },
});

export {
  useGiftcardsList,
  useGiftcard,
  useUpdateGiftcardMutation,
  useCreateGiftcardMutation,
  useDeleteGiftcardMutation,
};
